import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
    income: {
        borderBottom: "12px solid rgba(0, 255, 0, 0.6)",
    },
    expense: {
        borderBottom: "12px solid rgba(255, 0, 0, 0.6)",
    }
}));